import { withInstall } from '@lit-element/utils'

import EditorMd from './src/editor-md.vue'
import RenderMd from './src/components/render-md.vue'
import type { SFCWithInstall } from '@lit-element/utils'

export * from './src/editor-md-types'
export * from './src/plugins/checkbox'

export const LtEditorMd: SFCWithInstall<typeof EditorMd> = withInstall(EditorMd)
export default LtEditorMd

export const LtRenderMd: SFCWithInstall<typeof RenderMd> = withInstall(RenderMd)

export type EditorMdInstance = InstanceType<typeof EditorMd>
export type RenderMdInstance = InstanceType<typeof RenderMd>
